import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InputWrapper } from "./InputWrapper";
export const Checkbox = (props) => {
    const { formLabel, errorMessage, ...rest } = props;
    return (_jsx(InputWrapper, { isRadioCheckbox: true, formName: rest.name, formLabel: formLabel, errorMessage: errorMessage, children: _jsxs("span", { className: "ktc-checkbox", children: [_jsx("input", { type: "checkbox", ...rest }), _jsx("label", { className: "control-label", htmlFor: rest.name, children: formLabel })] }) }));
};
